<template>
  <div class="activation-code">
    <div class="activation-code-charts">
      <ActivationCodeChart
        echartType="免费激活码使用"
        leftType="免费激活码总使用"
        :leftBg="require('@/assets/common/free.png')"
        :getStatFunc="getFreeCodeStat"
      />
      <ActivationCodeChart
        echartType="收费激活码使用"
        leftType="收费激活码总使用"
        :leftBg="require('@/assets/common/pay.png')"
        :getStatFunc="getPayCodeStat"
      />
    </div>
    <div class="activation-code-list">
      <CommonTable
        ref="activation-code-list"
        tableType="激活码使用详情"
        :keys="codeKeys"
        :count="count"
        :list="codeList"
        :btns="codeBtns"
        @download="download"
        @changePagingParams="changePagingParams"
        @onSortChange="onSortChange"
      >
        <template v-slot:table-filter>
          <div class="slot-box">
            <div class="slot-box-left">
              <SelectCom
                placeholder="请选择收费状态"
                v-model="filterParams.level"
                :options="levelList"
              />
              <SelectCom
                placeholder="请选择激活码类型"
                v-model="filterParams.roleTag"
                :options="tagList"
              />
              <CommonInput
                v-model="filterParams.title"
                placeholder="按标题搜索"
              />
            </div>
          </div>
        </template>
      </CommonTable>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { mapActions } from 'vuex'
import { exportXlsx, formatDimTimeId, getYearWeek } from '@/utils/common'
import ActivationCodeChart from './ActivationCodeChart'
import CommonTable from '../common/CommonTable'
import SelectCom from '../common/SelectCom'
import CommonInput from '../common/CommonInput'

const tagMap = new Map([
  ['campus', '校本'],
  ['430', '社团'],
  ['org', '机构'],
  ['vip', '会员'],
])

export default {
  name: 'ActivationCode',
  components: {
    ActivationCodeChart,
    CommonTable,
    SelectCom,
    CommonInput,
  },
  data() {
    return {
      filterParams: {
        roleTag: '',
        level: '',
        title: '',
        orderBy: '',
        order: '',
      },
      pagingParams: {
        page: 1,
        pageSize: 10,
      },
      levelList: [
        {
          value: 2,
          label: '收费',
        },
        {
          value: 1,
          label: '免费',
        },
      ],
      tagList: [
        {
          value: 'campus',
          label: '校本',
        },
        {
          value: '430',
          label: '社团',
        },
        {
          value: 'org',
          label: '机构',
        },
        {
          value: 'vip',
          label: '会员',
        },
      ],
      codeKeys: [
        {
          prop: 'title',
          label: '标题',
          width: '120',
        },
        {
          prop: 'roleTag',
          label: '激活码类型',
        },
        {
          prop: 'level',
          label: '是否收费',
        },
        {
          prop: 'useTime',
          label: '使用时限',
        },
        {
          prop: 'amount',
          label: '开通数量',
          align: 'right',
          sortable: 'custom',
        },
        {
          prop: 'activateAmount',
          label: '已激活数量',
          align: 'right',
          sortable: 'custom',
        },
        {
          prop: 'unActivateAmount',
          label: '未激活数量',
          align: 'right',
        },
        {
          prop: 'expireTime',
          label: '到期时间',
          sortable: 'custom',
        },
        {
          prop: 'regionName',
          label: '使用区域',
        },
        {
          prop: 'createdAt',
          label: '创建时间',
          sortable: 'custom',
        },
      ],
      count: 0,
      codeList: [],
      codeBtns: [
        {
          text: '查看详情',
          onClick: row => {
            this.$router.push({
              name: 'PayDetail',
              query: {
                recordId: row.id,
                recordTitle: row.title,
                scrollTo: 'code',
              },
            })
          },
        },
      ],
    }
  },
  watch: {
    filterParams: {
      deep: true,
      handler() {
        this.$refs['activation-code-list'].handleSizeChange(10)
        this.pagingParams = {
          page: 1,
          pageSize: 10,
        }
        this.debounce()
      },
    },
    pagingParams: {
      deep: true,
      handler() {
        this.debounce()
      },
    },
  },
  created() {
    if (this.$route.query.level) {
      this.filterParams = {
        ...this.filterParams,
        level: this.$route.query.level,
      }
    }
    this.onGetCodeList()
  },
  methods: {
    ...mapActions({
      getAgentStat: 'newStat/getAgentStat',
      getActivateCodeList: 'newStat/getActivateCodeList',
    }),
    debounce: _.debounce(function () {
      this.onGetCodeList()
    }, 300),
    async onGetCodeList() {
      const { count, rows } = await this.onGetCodeListFunc()
      this.count = count
      this.codeList = rows
    },
    async onGetCodeListFunc(noPage = false) {
      let params = {
        noPage,
      }
      if (this.filterParams.order) {
        params = {
          ...params,
          sortDirect: this.filterParams.order,
          sortField: this.filterParams.orderBy,
        }
      }
      if (noPage === false) {
        params = {
          ...params,
          'x-page': this.pagingParams.page,
          'x-per-page': this.pagingParams.pageSize,
        }
      }
      if (this.filterParams.title) {
        params.title = this.filterParams.title
      }
      if (this.filterParams.level) {
        params.level = this.filterParams.level
      }
      if (this.filterParams.roleTag) {
        params.roleTag = this.filterParams.roleTag
      }
      const { count, rows } = await this.getActivateCodeList(params)
      const codeList = rows.map(item => {
        let useTime = ''
        if (item.startTime && item.endTime) {
          useTime = `${moment(item.startTime).format('YYYY-MM-DD')} 至 ${moment(
            item.endTime
          ).format('YYYY-MM-DD')}`
        }
        let expireTime = ''
        if (item.type === 3) {
          const expireTimeStr = _.get(_.split(item.expireTime, 'T'), '0', '')
          expireTime =
            expireTimeStr === '3020-12-31'
              ? '永久有效'
              : moment(item.expireTime).format('YYYY-MM-DD')
        }
        return {
          ...item,
          useTime,
          unActivateAmount: item.amount - item.activateAmount,
          regionName: item.regions.map(item => item.fullname).join('，'),
          roleTag: tagMap.get(item.tag),
          level: item.level === 2 ? '是' : '否',
          expireTime,
          createdAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm'),
        }
      })
      return {
        count,
        rows: codeList,
      }
    },
    async getYesterdayCodeStat() {
      const yesterdayDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      const params = {
        unit: 'day',
        startTime: yesterdayDate,
        endTime: yesterdayDate,
      }
      return await this.getAgentStat(params)
    },
    async getFreeCodeStat(params) {
      return await this.getCodeStat(
        params,
        'free-code-chart',
        'freeActivateCodeUseTotal',
        'freeActivateCodeUseIncrement'
      )
    },
    async getPayCodeStat(params) {
      return await this.getCodeStat(
        params,
        'pay-code-chart',
        'payActivateCodeUseTotal',
        'payActivateCodeUseIncrement'
      )
    },
    async getCodeStat(params, echartEl, leftTotalKey, chartKey) {
      const yesterdayCodeStat = await this.getYesterdayCodeStat()
      const stats = await this.getAgentStat(params)
      let xAxisData = []
      const seriesData = {
        data: [],
        type: 'line',
      }
      const startTime = moment(params.startTime)
      const endTime = moment(params.endTime)
      function formatStat(data) {
        data.forEach(item => {
          const curStat = stats.find(
            stat => formatDimTimeId(stat.dimTimeId) === item
          )
          if (curStat) {
            seriesData.data.push(curStat[chartKey] || 0)
          } else {
            seriesData.data.push(0)
          }
        })
      }
      if (params.unit === 'day') {
        while (startTime <= endTime) {
          xAxisData.push(startTime.format('YYYY-MM-DD'))
          startTime.add(1, 'days')
        }
        formatStat(xAxisData)
      }

      if (params.unit === 'week') {
        let startWeeks = getYearWeek(startTime)
        const endWeeks = getYearWeek(endTime)
        while (startWeeks < endWeeks) {
          xAxisData.push(startTime.endOf('isoweek').format('YYYY-MM-DD'))
          startWeeks += 1
          startTime.add(1, 'weeks')
        }
        formatStat(xAxisData)
      }
      if (params.unit === 'month') {
        let startMonth = _.toNumber(startTime.format('MM'))
        const endMonth = _.toNumber(endTime.format('MM'))
        const xData = []
        while (startMonth < endMonth) {
          xData.push(startTime.endOf('month').format('YYYY-MM-DD'))
          xAxisData.push(`${startMonth}月`)
          startMonth += 1
        }
        formatStat(xData)
      }
      return {
        echartEl,
        leftTotal: _.get(yesterdayCodeStat, `0.${leftTotalKey}`, 0),
        hasStat: xAxisData.length > 0,
        echartOptions: {
          tooltip: {
            trigger: 'axis',
          },
          xAxis: {
            type: 'category',
            data: xAxisData,
            boundaryGap: false,
            splitLine: { show: false },
            axisTick: { show: false },
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            splitLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
            axisTick: { show: false },
            axisLine: { show: false },
          },
          series: seriesData,
        },
      }
    },
    async download() {
      const { rows } = await this.onGetCodeListFunc(true)
      if (rows.length > 0) {
        exportXlsx('激活码列表', this.codeKeys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
    changePagingParams(paging) {
      this.pagingParams = paging
    },
    onSortChange(params) {
      this.filterParams = {
        ...this.filterParams,
        ...params,
      }
    },
  },
}
</script>

<style lang="scss">
.activation-code {
  .activation-code-charts {
    display: flex;
    justify-content: space-between;
    & > div {
      width: 49%;
    }
  }
  .activation-code-list {
    margin-top: 20px;
  }
}
</style>